import React from "react";

interface TerminosModalProps {
  isOpen: boolean;
  onClose: () => void;
  tipo: "terminos" | "privacidad";
}

export const TerminosModal: React.FC<TerminosModalProps> = ({
  isOpen,
  onClose,
  tipo,
}) => {
  if (!isOpen) return null;

  const esTerminos = tipo === "terminos";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">
            {esTerminos ? "Términos y Condiciones" : "Política de Privacidad"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto flex-1 px-6 py-4">
          <div className="text-sm text-gray-600 mb-4">
            Última actualización: {new Date().toLocaleDateString("es-CL")}
          </div>

          {esTerminos ? (
            <div className="space-y-6 text-gray-700">
              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  1. Aceptación de los Términos
                </h3>
                <p className="mb-4">
                  Al acceder y utilizar los servicios de Fracto, usted acepta
                  estar sujeto a estos Términos y Condiciones. Si no está de
                  acuerdo con alguna parte de estos términos, no debe utilizar
                  nuestros servicios.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  2. Descripción del Servicio
                </h3>
                <p className="mb-4">
                  Fracto es una plataforma educativa digital diseñada para
                  apoyar a estudiantes en su proceso de orientación vocacional,
                  postulación y preparación para la educación superior. Nuestros
                  servicios incluyen herramientas de aprendizaje, simulaciones y
                  recursos educativos.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  3. Uso Aceptable
                </h3>
                <p className="mb-2">Usted se compromete a:</p>
                <ul className="list-disc pl-6 space-y-1 mb-4">
                  <li>
                    Utilizar la plataforma únicamente para fines educativos
                  </li>
                  <li>No compartir su cuenta con terceros</li>
                  <li>
                    No realizar actividades que puedan dañar o interferir con el
                    funcionamiento de la plataforma
                  </li>
                  <li>Respetar los derechos de propiedad intelectual</li>
                  <li>Proporcionar información veraz y actualizada</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  4. Privacidad y Protección de Datos
                </h3>
                <p className="mb-4">
                  La protección de su privacidad es fundamental para nosotros.
                  Recopilamos y procesamos sus datos personales de acuerdo con
                  nuestra Política de Privacidad, cumpliendo con la legislación
                  chilena de protección de datos personales (Ley N° 19.628).
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  5. Propiedad Intelectual
                </h3>
                <p className="mb-4">
                  Todo el contenido, software, diseño y funcionalidades de
                  Fracto son propiedad de Fracto o sus licenciantes. Usted no
                  puede copiar, modificar, distribuir o crear obras derivadas
                  sin autorización expresa por escrito.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  6. Limitación de Responsabilidad
                </h3>
                <p className="mb-4">
                  Fracto se proporciona "tal como está". No garantizamos que el
                  servicio esté libre de errores o interrupciones. En ningún
                  caso Fracto será responsable por daños indirectos,
                  incidentales o consecuenciales.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  7. Modificaciones
                </h3>
                <p className="mb-4">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las modificaciones entrarán en vigor
                  inmediatamente después de su publicación en nuestro sitio web.
                  Su uso continuado del servicio constituye la aceptación de los
                  términos modificados.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  8. Terminación
                </h3>
                <p className="mb-4">
                  Podemos suspender o terminar su acceso al servicio en
                  cualquier momento, con o sin causa, con o sin previo aviso.
                  Usted puede terminar su cuenta en cualquier momento
                  contactándonos.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  9. Ley Aplicable
                </h3>
                <p className="mb-4">
                  Estos términos se rigen por las leyes de la República de
                  Chile. Cualquier disputa será resuelta por los tribunales
                  competentes de Santiago, Chile.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  10. Contacto
                </h3>
                <p className="mb-2">
                  Si tiene preguntas sobre estos Términos y Condiciones, puede
                  contactarnos en:
                </p>
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                  <p className="font-semibold mb-1">Email:</p>
                  <p className="mb-2">hola@fracto.cl</p>
                  <p className="font-semibold mb-1">Sitio web:</p>
                  <p>www.fracto.cl</p>
                </div>
              </section>
            </div>
          ) : (
            <div className="space-y-6 text-gray-700">
              <section>
                <p className="mb-4 font-semibold">
                  FRACTO ha redactado estas Políticas de Privacidad aplicables
                  en el uso de sus sitios web, aplicaciones móviles y servicios
                  relacionados de la aplicación (en adelante el "Servicio"). Al
                  usar el Servicio aceptas que FRACTO recopile, use y comparta
                  tu información personal de acuerdo con los términos de esta
                  Política de Privacidad.
                </p>
                <p className="mb-4">
                  Como responsable del tratamiento de Datos Personales recogidos
                  en el Servicio, FRACTO informa a los usuarios que se ubica en
                  Chile, Región Metropolitana y que la base jurídica para el
                  tratamiento de los Datos Personales y el plazo de su
                  conservación en la base de datos, serán indicados en esta
                  Política de Privacidad, la cual se encuentra orientada y
                  construida en respeto a la Ley 19.268, la Ley 21.719 sobre
                  Protección de Datos Personales en Chile y los estándares
                  internacionales como la Ley Norteamericana COPPA "Children's
                  Online Privacy Protection Act".
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  1. Recopilación de datos personales
                </h3>
                <p className="mb-4">
                  Mientras utilices el Software, recopilaremos datos personales
                  de contacto, como nombres completos, direcciones de correo
                  electrónico, números de teléfono, empresa o cargo, edad y
                  otros datos relevantes, pero también datos de uso. Estos datos
                  se recopilarán a través de formularios o cuestionarios
                  específicos. Al proporcionar sus datos, usted acepta
                  voluntariamente su recopilación y uso de acuerdo con esta
                  Política de Privacidad.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  2. Cómo utilizamos la información
                </h3>
                <p className="mb-4">
                  FRACTO utilizará la información proporcionada para prestar y
                  gestionar de mejor forma la aplicación, mejorar la atención al
                  cliente, personalizar la experiencia del usuario y
                  proporcionar las funciones disponibles en la plataforma.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  3. Sobre los usuarios menores de 13 años
                </h3>
                <p className="mb-4">
                  FRACTO está pensado y creado para que niños, niñas y
                  adolescentes puedan utilizarlo sin mayor riesgo y en estricto
                  resguardo de sus derechos. Respecto a los usuarios menores de
                  13 años, estos podrán crear una cuenta en FRACTO, pero se
                  solicitará que acompañen un correo electrónico de una persona
                  mayor de edad.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  4. FRACTO para Instituciones Educacionales
                </h3>
                <p className="mb-4">
                  FRACTO ofrece un servicio adicional para Instituciones
                  Educacionales e Instituciones Privadas. FRACTO para
                  profesores, es una plataforma web en la que los
                  profesores/administrativos/tutores podrán tener acceso a la
                  información de progreso de cada alumno.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  5. Sobre la protección de Datos Personales
                </h3>
                <p className="mb-4">
                  FRACTO adopta medidas razonables y proporcionales para
                  proteger la información personal frente a accesos no
                  autorizados, pérdida, uso indebido o alteración por parte de
                  terceros.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  6. Derechos del usuario
                </h3>
                <p className="mb-2">
                  Como usuario tiene derechos sobre sus datos personales:
                </p>
                <ul className="list-disc pl-6 space-y-1 mb-4">
                  <li>
                    Solicitar acceder, corregir, eliminar o limitar el uso de
                    sus datos
                  </li>
                  <li>
                    Conocer que datos hemos recopilado y cómo los hemos
                    utilizado
                  </li>
                  <li>Retirar en cualquier momento cualquier consentimiento</li>
                  <li>Eliminar el Software</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  7. Base de datos y resguardo de datos
                </h3>
                <p className="mb-4">
                  FRACTO conservará la información personal de los alumnos hasta
                  la eliminación definitiva de la cuenta correspondiente.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  8. Actualización de estas Políticas de Privacidad
                </h3>
                <p className="mb-4">
                  Podemos actualizar nuestra Política de Privacidad, y si los
                  cambios son sustanciales informaremos oportunamente a cada
                  Institución que haya contratado.
                </p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 border-b-2 border-blue-200 pb-1">
                  9. Contacto
                </h3>
                <p className="mb-2">
                  Si tienes cualquier consulta acerca de esta Política, por
                  favor contáctanos:
                </p>
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                  <p className="font-semibold mb-1">Email:</p>
                  <p className="mb-2">hola@fracto.cl</p>
                  <p className="font-semibold mb-1">Sitio web:</p>
                  <p>www.fracto.cl</p>
                </div>
              </section>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
